import { CircleX, TriangleAlert } from "lucide-react";

interface NotificationsBarProps {
  hidden?: boolean;
}

const NotificationsBar = ({ hidden }: NotificationsBarProps) => {
  const handleClose = () => {
    console.log("To be implemented");
  };

  if (hidden) return null;

  return (
    <>
      <div className="bg-amber-600 text-white p-2 px-4 rounded-b-lg lg:mx-4">
        <div className=" container mx-auto flex">
          <div className="mr-2">
            <TriangleAlert />
          </div>{" "}
          <div className="flex-auto text-sm px-2">
            This is a system notification. We use this to inform the user about a potential interruption to the system
            or to the business generally. These aren't designed to replace the practice notices.
          </div>
          <div onClick={() => handleClose()} className="hover:cursor-pointer">
            <CircleX />
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificationsBar;
